import React, { useRef, useState, useEffect } from 'react';
import CardContainer from './CardContainer.redesign';
import { ITableConfig } from 'src/components/common/table';
import * as _ from 'lodash';
import { ODataOptions, ODataOrderByDirection } from 'src/util/ODataBuilder';

export interface IPagedItemProps {
    className?: string;
    resetLastPage?: boolean;
    ResetStateCallback: () => void;
    optionalCondition?: boolean;
    style?: React.CSSProperties;
    resultsLabelStyle?: React.CSSProperties;
    orderByColumn?: string;
    orderByDirection?: ODataOrderByDirection;
    startingPage: number;
    rowsPerPage?: number;
    totalRows: number;
    dataOptions: ODataOptions;
    DisplayList: () => React.ReactNode;
    GetPagedItemList: (dataOptions: ODataOptions, resetSearch: boolean) => void;
    noContainer?: boolean;
    noContainerNextPageAction?: () => void;
}

const PagedItemList: React.FC<IPagedItemProps> = (props) => {
    const [pagingDataOptions, setPagingDataOptions] = useState(() => new ODataOptions());
    const [isOnLastPage, setIsOnLastPage] = useState(false);
    const [listScrollTop, SetListScrollTop] = useState(0);
    const listContainerRef = useRef(null);

    useEffect(() => {
        createDataOptions();
        setIsOnLastPage(false);
        SetListScrollTop(listContainerRef?.current?.clientHeight);
    }, []);

    useEffect(() => {
        setPagingDataOptions(props.dataOptions);
    }, [props.dataOptions]);

    const createDataOptions = () => {
        const initialOptionsConfig: ITableConfig = { rowCount: props.rowsPerPage, pageNumber: props.startingPage};
        let configOptions = ODataOptions.from(initialOptionsConfig);
        let tempDataOptions = new ODataOptions();
        tempDataOptions.addOrderBy(props.orderByColumn, props.orderByDirection);
        tempDataOptions.addPaging(props.startingPage, props.rowsPerPage);
        tempDataOptions.merge(configOptions);
        setPagingDataOptions(tempDataOptions);
    };

    if (props.resetLastPage && isOnLastPage) {
        setIsOnLastPage(false);
        listContainerRef.current.scrollTo({ behavior: 'instant', top: listScrollTop > 0 ? listScrollTop : 100 });
    }

    const incrementPage = () => {
        if (!isOnLastPage && props.totalRows > pagingDataOptions.getPageSize()) {
            pagingDataOptions.incrementPageNumber();
            pagingDataOptions.setIsNextpage(true);
            props.GetPagedItemList(pagingDataOptions, false);
            setIsOnLastPage(pagingDataOptions.getPageNumber() * pagingDataOptions.getPageSize() >= props.totalRows);
        }
    }; 

    const pagedItemListResult: React.ReactNode[] = [];
    const pagedItemListHeader: React.ReactNode[] = [];
    pagedItemListHeader.push(
        <div style={{ textAlign: 'center', backgroundColor: '#f9f9f9', position: 'sticky', ...props.resultsLabelStyle}}>
            Results {props.totalRows > 0 ? props.startingPage : 0} - {props.totalRows < pagingDataOptions?.getPageSize() * pagingDataOptions?.getPageNumber()
                ? props.totalRows : (pagingDataOptions?.getPageSize() * pagingDataOptions?.getPageNumber() < props.totalRows
                ? pagingDataOptions?.getPageSize() * pagingDataOptions?.getPageNumber() : props.totalRows)} of {props.totalRows}.
        </div>
    );
    
    props.noContainer ? pagedItemListResult.push(props.DisplayList()) :
    pagedItemListResult.push(
        <div ref={listContainerRef} className={props.className} style={props.style}>
            <div className="dlc-paged-items">{props.children}</div>
            <CardContainer
                showNextPagePanel={!isOnLastPage && props.optionalCondition}
                nextPageAction={incrementPage}
            >
                {props.DisplayList()}
            </CardContainer>
        </div>
    );

    return (
        <>
            {pagingDataOptions && pagedItemListHeader}
            {pagedItemListResult}
        </>
    );
};

PagedItemList.defaultProps = {
    optionalCondition: true,
    startingPage: 1,
    orderByDirection: ODataOrderByDirection.Descending,
};

PagedItemList.displayName = 'PagedItems';
export default PagedItemList;


// WEBPACK FOOTER //
// ./src/components/common/PagedItemList.tsx